import React from "react";
import AQ from "./AQ";
import QA from "./QA";
import "./index.model.less";

export default (props) => {
  let { info } = props;
  if (info.preferences?.childPrefer?.direction) {
    return <AQ {...props} />;
  } else {
    return <QA {...props} />;
  }
};
